import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    uploadProgress: null,
    uploadStarted: false,
  },
  reducers: {
    setAttachmentUploadProgress: (state, action) => {
      const { progress, uploadStarted } = action.payload;
      state.uploadStarted = uploadStarted;
      state.uploadProgress = progress;
    },
  },
});

export const { setAttachmentUploadProgress } = chatSlice.actions;

export const selectUploadProgress = state => state.chat.uploadProgress;
export const selectUploadStarted = state => state.chat.uploadStarted;

export default chatSlice.reducer;
